import React from "react";
import { Formik, Field, Form, FieldArray } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import { transformTranslateFromValues, dateTimeToserver } from "lib/helpers";
import Modal from "components/Modal";
import { TextArea } from "components/form";
import { GalleryField } from "components/form";
import SearchSelect from "utils/SearchSelect";
import MultySearchSelect from "utils/MultySearchSelect";
import extractValues from "utils/extractValues";
import MetaDataComponent from "utils/MetaDataComponent";
import TextFieldSlug from "components/form/TextFieldSlug";
// components

const status = [
  { label: "برنامه ریزی شده", value: "scheduled" },
  { label: "درحال اجرا", value: "ongoing" },
  { label: "تکمیل شده", value: "completed" },
  { label: "به تعویق افتاد", value: "postponed" },
  { label: "کنسل شده", value: "canceled" },
];

export default function Add(props) {
  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{}}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            if (values.birthday)
              values.birthday = dateTimeToserver(values.birthday, "YYYY-MM-DD");

            const result = extractValues(values, [
              "league",
              "homeTeam",
              "awayTeam",
              "winner",
            ]);

            await props.submit(result);
            resetForm();
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ values, isSubmitting, dirty, setFieldValue }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="نام"
                    label="نام:"
                    name="translations.fa.name"
                    slugFieldName="translations.fa.slug"
                    component={TextFieldSlug}
                  />
                  <Field
                    placeholder="name(en)"
                    label="name(en) :"
                    name="translations.en.name"
                    slugFieldName="translations.en.slug"
                    component={TextFieldSlug}
                  />
                  <Field
                    placeholder="نامک"
                    label="نامک:"
                    name="translations.fa.slug"
                    component={TextField}
                  />
                  <Field
                    placeholder="نامک(en)"
                    label="نامک(en) :"
                    name="translations.en.slug"
                    component={TextField}
                  />

                  <div className="intro-y">
                    <Field
                      label="لیگ مرتبط :"
                      name="league"
                      component={SearchSelect}
                      searchFields="translations.name"
                      collectionName="leagueNew"
                      showFields="translations.name"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="user-datepicker">
                    <Field
                      label="تاریخ بازی :"
                      name="matchDate"
                      component={PersianDataPicker}
                    />
                  </div>

                  <div className="intro-y">
                    <span> شماره هفته بازی در لیگ :</span>
                    <Field
                      label="شماره هفته بازی در لیگ : "
                      name="weekNumber"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label=" تیم میزبان:"
                      name="homeTeam"
                      component={SearchSelect}
                      searchFields="translations.name"
                      collectionName="teamNew"
                      showFields="translations.name"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label=" تیم مهمان:"
                      name="awayTeam"
                      component={SearchSelect}
                      searchFields="translations.name"
                      collectionName="teamNew"
                      showFields="translations.name"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label="وضعیت بازی :"
                      name="status"
                      component={Select}
                      options={status}
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <span> تعداد گل تیم میزبان :</span>
                    <Field
                      label="تعداد گل تیم میزبان  : "
                      name="homeGoals"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <span> تعداد گل تیم مهمان :</span>
                    <Field
                      label="تعداد گل تیم مهمان  : "
                      name="awayGoals"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label=" برنده:"
                      name="winner"
                      component={SearchSelect}
                      searchFields="translations.name"
                      collectionName="teamNew"
                      showFields="translations.name"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <Field
                    placeholder="لینک پخش زنده بازی"
                    label="لینک پخش زنده بازی :"
                    name="broadcastUrl"
                    component={TextField}
                  />

                  <Field
                    placeholder="زمان شروع بازی"
                    label="زمان شروع بازی :"
                    name="startTime"
                    component={TextField}
                  />
                </div>
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
